var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showButton)?_c('v-btn',{staticClass:"secondary-button text-btn",attrs:{"data-test":"billing-activation-button","loading":_vm.trialLoading},on:{"click":_vm.handlePremium}},[_c('e-svg-icon',{staticClass:"mr-2"},[_vm._v("flash-primary")]),_c('span',[_vm._v(_vm._s(_vm.buttonText))])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }